import { render, staticRenderFns } from "./InfoCards.vue?vue&type=template&id=e6901e22&scoped=true&"
import script from "./InfoCards.vue?vue&type=script&lang=js&"
export * from "./InfoCards.vue?vue&type=script&lang=js&"
import style0 from "./InfoCards.vue?vue&type=style&index=0&id=e6901e22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6901e22",
  null
  
)

export default component.exports